<div class="flex w-[220px] flex-col gap-[5.5px] rounded-2xl border-2 border-primary-blue p-2 pl-3">
  <div class="flex items-center gap-3">
    @if (isCondition()) {
      <lib-status-box [status]="ProgressNoteStatus.CON"></lib-status-box>
    } @else {
      <lib-select-status
        triggerType="small"
        [selectedStatus]="status()"
        (statusChange)="onTreatmentStatusChange($event)"
      ></lib-select-status>
    }

    <ng-template #editTooltip>
      <div class="typo-h5-book">
        {{ 'charting_add_treatment_edit_label' | translate }}
      </div>
    </ng-template>
    <ng-template #removeTooltip>
      <div class="typo-h5-book">
        {{ 'charting_add_treatment_remove_label' | translate }}
      </div>
    </ng-template>

    @for (tag of treatmentTags(); track $index) {
      <button
        (click)="onEditTreatment(tag)"
        [class.truncate]="tag.isSurface"
        [ngClass]="tagClass"
        [libUiTooltip]="editTooltip"
        tooltipPosition="top"
      >
        {{ tag.title }}
      </button>
    }
    @if (isFullMouth()) {
      <button [ngClass]="tagClass" class="!cursor-default">
        {{ `charting_add_treatment_full_mouth` | translate }}
      </button>
    }

    <button class="btn-icon-small ml-auto" [libUiTooltip]="removeTooltip" tooltipPosition="bottom" (click)="onRemoveTreatment()">
      <svg-icon [key]="'px-16-x'"></svg-icon>
    </button>
  </div>

  <div class="flex gap-1">
    <span class="typo-h5-semibold text-primary-blue">{{ dentalCode() }} </span>
    <span class="typo-h5-semibold truncate text-text-primary">{{ description() }}</span>
  </div>
</div>
